export default "__VITE_PUBLIC_ASSET__ddc15bbc__"